const actions = {
    sendUserMessage({ commit }, payload) {
        this.http.postMessage(payload);
    },
    rateChat({ commit }, payload) {
        this.http.rateChat(payload.data, payload.partial_save);
    },
    sendAgentMessage({ commit }, payload) {
        /*
        commit('actionMessage', {
            sender: false,
            text: payload
        });*/
    },
    setOperators(state, operators) {
        state.operators = operators
    },

    setOperator(state, operator) {
        state.operator = operator
    },
    closeCurrentChat({ commit }, force_close) {
        // Clear any blocked-access banner when the user closes the chat.
        this.commit('setAccessBlockedMessage', null);
        // Even if the close request fails, a forced close must still return the widget to the menu.
        this.http.closeThread().catch(() => {}).then(
            () => {
                if (force_close) {
                    this.http.setThreadClosed();
                    this.commit('changeChatWindowStatus', 1)
                }
            }
        );
    },
    closeForm({ commit }){
        this.commit('setContactPhone', null);
        this.commit('setOpeningHours', null);
        this.commit('setClosingHours', null);
        // Clear any blocked-access banner when the contact form is dismissed.
        this.commit('setAccessBlockedMessage', null);
        this.commit('changeChatWindowStatus', 1)
    },
    sendOfflineMessage({ commit }, payload) {
        this.http.sendOfflineMessage(payload.message).then((response) => {
            if (payload.callback) {
                payload.callback(response);
            }
        }).catch((error) => {
            if (payload.errback) {
                payload.errback(error);
            }
        });
    },
    shareCartWithAgent({ commit }, payload) {
        this.http.shareUrlWithAgent(payload.share_url);
    },
    sendUserFiles({commit}, files){
        this.http.sendFiles(files);
    },
    deleteImage({commit}, image){
        this.http.deleteMessage(image);
    }
}
export default actions